import { gql } from '@apollo/client'

export const DROPDOWN_USER_QUERY = gql`
  query users($sortBy: UserSort, $filter: UserFilter) {
    users(sortBy: $sortBy, filter: $filter) {
      collection {
        id
        altName
        email
        active
        archived
        employeeHohner
      }
    }
  }
`
